import React, { useContext, useEffect, useState } from "react";
import { SetupDataPageTemplate } from "../../../components/setup-pages/SetupDataPageTemplate";
import { getOptionsElements, pathRoot, schema } from "../Compensation";
import { Form } from "react-jsonschema-form-validation";
import { setupData } from "../../../configs/routes";
import { sanitize } from "dompurify";
import he from "he";
import NumberFormat from "react-number-format";
import { DiseaseGroupContext } from "../../../contexts/diseaseGroupContext";

//if page 3 includes civil
export const Page4 = ({ compensation, handleSave }) => {
	const [claimSuccess, setClaimSuccess] = useState(compensation.claimSuccess);
	const [lawFirm, setLawFirm] = useState("");
	const [employer, setEmployer] = useState("");
	const [totalCompensation, setTotalCompensation] = useState(
		compensation.totalCompensation
	);

	const { theme } = useContext(DiseaseGroupContext);

	const claimSuccessOptions = [
		{
			label: "Success",
			value: 0,
		},
		{
			label: "Failed",
			value: 1,
		},
		{
			label: "Ongoing",
			value: 2,
		},
	];

	const headerDetails = {
		title: "Compensation",
		currentPage: 4,
		pageCount: 4,
	};

	useEffect(() => {
		setLawFirm(he.decode(compensation.lawFirm));
		setEmployer(he.decode(compensation.employer));
	}, [compensation.lawFirm, compensation.employer]);

	const onNext = () => {
		return new Promise((resolve, reject) => {
			compensation.claimSuccess = claimSuccess;
			compensation.lawFirm = lawFirm;
			compensation.employer = employer;
			compensation.totalCompensation = totalCompensation;

			handleSave(compensation).then(resolve).catch(reject);
		});
	};

	const handleLawFirmChange = (value) => {
		const clean = sanitize(value);
		setLawFirm(he.decode(clean));
	};

	const handleEmployerChange = (value) => {
		const clean = sanitize(value);
		setEmployer(he.decode(clean));
	};

	return (
		<SetupDataPageTemplate
			headerDetails={headerDetails}
			backTo={`${pathRoot}/3`}
			nextTo={setupData}
			onClickNext={onNext}
			nextTextOverride={"Finish"}
		>
			<Form schema={schema}>
				<p className={"text-lg sm:text-xl font-bold mb-6"}>
					If you are pursuing or receiving from a civil claim, we would be
					interested in knowing how you got on, in order to help others. Please
					complete the following if you are happy to do so...
				</p>
				<div>
					{getOptionsElements(
						claimSuccessOptions,
						"claimSuccess",
						claimSuccess,
						setClaimSuccess,
						theme
					)}
				</div>
			</Form>
			<div className="radioSelect pt-1 sm:pt-3">
				<div className={"mb-2 sm:mb-3"}>
					<label className={"basicFormLabel"} htmlFor={"lawFirm"}>
						Who was/is the law firm?
					</label>
					<div className="flex-grow">
						<input
							key="lawFirm"
							type="text"
							className={"formField"}
							id={"lawFirm"}
							name="lawFirm"
							placeholder={"Enter name"}
							value={lawFirm}
							onChange={(e) => handleLawFirmChange(e.target.value)}
						/>
					</div>
				</div>
				<div className={"mb-2 sm:mb-3"}>
					<label className={"basicFormLabel"} htmlFor={"employer"}>
						Who was/is the employer?
					</label>
					<div className="flex-grow">
						<input
							key="employer"
							type="text"
							className={"formField"}
							id={"employer"}
							name="employer"
							placeholder={"Enter name"}
							value={employer}
							onChange={(e) => handleEmployerChange(e.target.value)}
						/>
					</div>
				</div>
				<div>
					<label className={"basicFormLabel"} htmlFor={"totalCompensation"}>
						How much compensation?
					</label>
					<div className="w-full flex-grow">
						<NumberFormat
							value={totalCompensation}
							thousandSeparator={true}
							className={`formField block`}
							inputMode={"decimal"}
							decimalScale={2}
							onValueChange={(values) =>
								setTotalCompensation(parseFloat(values.floatValue))
							}
							allowNegative={false}
						/>
					</div>
				</div>
			</div>
		</SetupDataPageTemplate>
	);
};
